export default "__VITE_ASSET__BzEeZsVW__"